import {
  USER_AUTHORITY__FETCH_REQUEST,
  USER_AUTHORITY__FETCH_SUCCESS,
  USER_AUTHORITY__INITIALIZE,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_REQUEST,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import {
  checkSigningRequestAuthority,
  UserAuthorityAction,
} from '@app/store/user/authority/actions';

export type UserAuthorityPeriodState = { from: string; to: string } | null;

const initialState: UserAuthorityPeriodState = null;

export default function reducer(
  state: UserAuthorityPeriodState = initialState,
  action: UserAuthorityAction
) {
  if (checkSigningRequestAuthority.pending.match(action)) {
    return initialState;
  }

  switch (action.type) {
    case USER_AUTHORITY__FETCH_REQUEST:
    case USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_REQUEST:
      return initialState;
    case USER_AUTHORITY__FETCH_SUCCESS:
    case USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS:
      if (action.payload) {
        return action.payload.period;
      }
      return initialState;
    case USER_AUTHORITY__INITIALIZE:
      return initialState;
    default:
      return state;
  }
}
